'use strict';

const assertNative = require('./assertNative');
const getObjectWrapper = require('./getObjectWrapper');
const isConstructor = require('./isConstructor');

/**
 * Returns true if the given instance is an instance of cls.
 * Also works with primitive objects being checked against their
 * object wrapper classes, if they have one (e.g. null and
 * undefined do not, and thus are not instances of anything).
 *
 * @example
 *   isInstanceOf(new Foo(), Foo); // => true
 *   isInstanceOf([], Array); // => true
 *   isInstanceOf("hi", String); // => true
 *   isInstanceOf(null, Object); // => false
 *
 * @param  {*}  instance      Any value.
 * @param  {Function}  cls    A constructor function.
 * @return {Boolean}
 */
module.exports = function isInstanceOf (instance, cls) {
  if (!isConstructor(cls)) {
    throw new Error(`${cls} for isInstanceOf check is not a constructor function!`);
  }

  assertNative(instance);

  let wrappedObj = getObjectWrapper(instance);
  if (wrappedObj) {
    return wrappedObj instanceof cls;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isInstanceOf.js